module.exports = __webpack_public_path__ + "img/no_contact.a582806e.png";